import type { SeparatorBlockProps } from "./types";
import { SeparatorEmailRenderer } from "./email";
import { EmailComponentWrapper } from "../../utils/email-component-wrapper";


export function SeparatorEditorRenderer(buttonProps: SeparatorBlockProps) {
	return (
		<EmailComponentWrapper shop={buttonProps.shop}>
			<SeparatorEmailRenderer {...buttonProps} />
		</EmailComponentWrapper>
	);
}
